module.exports = __webpack_public_path__ + "img/back2.25f2c81e.svg";